module.exports = swea;